<template>
  <div>
    <Loader :flag="!flag.loaded">
      <SectionContainer>
        <SectionFrame
          :maxWidth="1080"
          :marginTop="50"
          :smMarginTop="50">
          <FlexList
            :spaceX="24"
            :spaceY="24"
            :count="3"
            :smCount="1"
            :wrap="true"
            v-if="lists?.length">
            <li v-for="item in lists" :key="item.id">
              <router-link :to="`/topics/${item.slug}/`" :class="s.itemLink">
                <ContentCard
                  :img="item.medias[0]?.url"
                  :imgRatio="70"
                  :smImgRatio="70"
                  :name="item.title"
                  :content="item.summary"
                  :contentBg="'wht'"
                  :radius="28"
                  :hasShadow="true"/>
              </router-link>
            </li>
          </FlexList>
          <div v-else-if="!flag.error && flag.loaded" :class="s.error"><span>該当の産地トピックスがありませんでした</span></div>
          <div v-else-if="flag.loaded" :class="s.error"><span>産地トピックスの読み込みに失敗しました</span></div>
        </SectionFrame>
      </SectionContainer>
      <spacer :y="20"/>
    </Loader>
  </div>
</template>

<script>
import {
  SectionContainer,
  SectionFrame,
  FlexList,
  ContentCard,
  Spacer,
  Loader,
} from '@/components/parts';

export default {
  name: 'Topics',
  components: {
    SectionContainer,
    SectionFrame,
    FlexList,
    ContentCard,
    Spacer,
    Loader,
  },
  data() {
    return {
      flag: {
        loaded: false,
        error: false,
      },
      lists: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const params = {
        frontend_type: 21,
        flags: [1],
        orderBy: 'updated_at',
        order: 'desc',
      };
      this.axios({
        method: 'GET',
        url: '/v1/topic/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.lists = res.list.data;
          this.flag.loaded = true;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.flag.error = true;
          this.flag.loaded = true;
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.itemLink {
  display: block;
  height: 100%;
  > * {
    height: 100%;
  }
}

.error {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  > * {
    padding: 8px 32px;
    display: inline-block;
    margin: 0 auto;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    opacity: .8;
  }
}
</style>
